
import { Options, Vue } from 'vue-class-component'
import { User } from '@/module/user'
import { Http, Urls } from '@/module/http'
import { ResponseData } from '@/module/response'
// import { loadMessages } from '@/plugins/i18n'
import { Language } from '@/module/language'

import ShowMessage from '@/components/ShowMessage.vue'

@Options({
  components: { ShowMessage },
  emits: {
    click: null,
    showappmessage: () => {
      return true
    }
  }
})

export default class Login extends Vue {
    password = ''
    messageContent = ''
    selectLanguage = Language.zh // 默认语言中文
    mounted () {
      this.judgeLanguage()
      if (User.isLogin()) {
        this.$router.push('/views/home')
      }
      this.$i18n.locale = this.selectLanguage
    }

    judgeLanguage () {
      if (!Language.get()) {
        const languages = navigator.languages // 识别浏览器语言
        if (languages) {
          const la = languages[0]
          // 中文 中文（简体）
          if (la === 'zh' || la === 'zh-CN') {
            this.selectLanguage = Language.zh
            Language.set(Language.zh)
            // 中文（繁体） 中文（香港）
          // } else if (la === 'zh-TW' || la === 'zh-HK') {
          //   latag = 2;
          //   // 德语 德语（德国） 德语（奥地利） 德语（列支敦士登） 德语（瑞士）
          // } else if (la === 'de' || la === 'de-DE' || la === 'de-AT' || la === 'de-LI' || la === 'de-CH') {
          //   latag = 4;
          //   // 韩语
          // } else if (la === 'ko') {
            // latag = 5;
            // 英语 英语（美国） 英语（英国） 英语（印度） 英语（新西兰） 英语（南非） 英语（加拿大） 英语（澳大利亚）
          } else if (la === 'en' || la === 'en-US' || la === 'en-GB' || la === 'en-IN' || la === 'en-NZ' || la === 'en-ZA' || la === 'en-CA' || la === 'en-AU') {
            this.selectLanguage = Language.en
            Language.set(Language.en)
          }
        }
      } else {
        this.selectLanguage = Language.get()
      }
    }

    switchLanguage () {
      this.changeLanguage(this.selectLanguage)
    }

    changeLanguage (lang: string) {
      this.$i18n.locale = lang
      Language.set(lang)
      window.location.href = '/'
    }

    // async changeLanguage (lang: string) {
    //   await loadMessages(lang)
    // }

    login () {
      const pwd = this.password.trim()
      const data = {
        password: pwd
      }
      Http.post<string>(Urls.login_url, data).then((res: string) => {
        User.set(res)
        this.$router.push('/views/home')
      }, (err: ResponseData) => {
        this.showMessage(err.Msg)
      })
    }

    showMessage (msg: string) {
      this.messageContent = msg
    }
}
